import { usePersonalizedDownloadLinkMutation } from 'services/api/personalized';
import { StudyActionRef } from 'helper/flux/myStudyRow';
import useStudyDownload from 'utils/hooks/flux/shared/useStudyDownload';

export { NO_LINK_MESSAGE, OPENED_IN_NEW_TAB_MESSAGE } from 'utils/hooks/flux/shared/useStudyDownload';

// Flux Personalizado: previvaz-personalizado/get-download-link
export default function usePersonalizedDownload(study: StudyActionRef) {
  return useStudyDownload(study, usePersonalizedDownloadLinkMutation);
}
